import { Ref } from 'preact'
import { useMemo } from 'preact/hooks'

export function mergeRefs<RT = Element>(this: void, ...refs: Array<Ref<RT>>): Ref<RT> {
  return value => {
    refs.forEach(ref => {
      if (typeof ref === 'function') {
        ref(value)
      } else if (ref != null) {
        ref.current = value
      }
    })
  }
}

export function useMergeRefs<RT = Element>(this: void, ...refs: Array<Ref<RT>>): Ref<RT> {
  return useMemo<Ref<RT>>(() => mergeRefs(...refs), refs)
}
